import "./TableInstructionText.css";

const TableInstructionText = ({ text }: { text: string }) => {
  return <p id="tableInstructionText">{text}</p>;
};

export default TableInstructionText;
